import { computed, signal } from '@angular/core';

export interface FlowpilotChat {
  name: string;
  pinned?: boolean;
  id: number;
}

export class FlowpilotChatService {
  /** PROPERTIES **/
  /** TODO add fetch to get chats from AI backend **/
  private _chatsSignal = signal<FlowpilotChat[]>([]);

  public get chatsSignal() {
    return this._chatsSignal.asReadonly();
  }

  /****/
  private readonly _selectedChatId = signal(-1);

  /****/
  private readonly selectedChat = computed(() =>
    this._chatsSignal().find(chat => chat.id === this._selectedChatId())
  );

  public get selectedChatSignal() {
    return this.selectedChat;
  }

  public selectChat(id: number) {
    this._selectedChatId.set(id);
  }

  public updateChatName(id: number, newName: string) {
    this._chatsSignal.update(cur =>
      cur.map(chat => (chat.id === id ? { ...chat, name: newName } : chat))
    );
  }
}
